module.exports = __webpack_public_path__ + "static/media/regression.2c3578f5.jpg";